import { render, staticRenderFns } from "./TxnProcessForm.vue?vue&type=template&id=41769f68&"
import script from "./TxnProcessForm.vue?vue&type=script&lang=ts&"
export * from "./TxnProcessForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports